// src/shell/Header.jsx
import React, { useState } from 'react';
import { KeyRound } from 'lucide-react';
import { useAuth } from '../auth/AuthContext.jsx';
import { API_BASE_URL } from '../services/api/config.js';
import ChangeOwnPasswordModal from '../admin/pages/ChangeOwnPasswordModal.jsx';

export default function Header({ hamburgerBtn }) {
  const { user, activeTenant, logout, adminMode } = useAuth();
  const [showChangePw, setShowChangePw] = useState(false);

  return (
    <>
      <style>{`
        .shell-header {
          height: 52px;
          border-bottom: 1px solid rgba(0,0,0,0.08);
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 20px;
          background: #ffffff;
          flex-shrink: 0;
        }
        .shell-header-email { font-size: 12px; color: #3a3a3c; }
        .shell-header-pwbtn { display: inline-flex; align-items: center; gap: 4px; }
        @media (max-width: 768px) {
          .shell-header { padding: 0 12px; }
          .shell-header-email { display: none; }
          .shell-header-pwbtn { display: none; }
        }
      `}</style>
      <header className="shell-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          {hamburgerBtn}
          {adminMode ? (
            <span style={{ fontSize: '14px', fontWeight: 700, color: '#E8002D', fontFamily: "'DM Sans', sans-serif" }}>
              ESC Agency SRL
            </span>
          ) : (
            <>
              {activeTenant?.logo_url && (
                <img
                  src={`${API_BASE_URL}${activeTenant.logo_url}`}
                  alt={activeTenant.display_name || 'Logo'}
                  style={{ height: '40px' }}
                />
              )}
              {activeTenant && (
                <span style={{ fontSize: '12px', color: '#6c6c6d', fontFamily: "'JetBrains Mono', monospace" }}>
                  {activeTenant.display_name}
                </span>
              )}
            </>
          )}
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          {user?.email && (
            <span className="shell-header-email">{user.email}</span>
          )}
          <button
            onClick={() => setShowChangePw(true)}
            className="shell-header-pwbtn"
            style={{ padding: '5px 10px', borderRadius: '6px', border: '1px solid rgba(0,0,0,0.12)', background: 'transparent', color: '#3a3a3c', fontSize: '11px', cursor: 'pointer' }}
          >
            <KeyRound size={12} /> Cambia password
          </button>
          <button
            onClick={logout}
            style={{ padding: '5px 12px', borderRadius: '6px', border: '1px solid rgba(0,0,0,0.12)', background: 'transparent', color: '#3a3a3c', fontSize: '12px', cursor: 'pointer' }}
          >
            Esci
          </button>
        </div>
      </header>
      <ChangeOwnPasswordModal open={showChangePw} onClose={() => setShowChangePw(false)} />
    </>
  );
}
